import type { ReactNode } from "react";
import { ApiProblem, formatProblem } from "../../api/problemDetails";

export function LoadingState({ label = "Loading…" }: { label?: string }): React.JSX.Element {
  return <div className="state state-loading" role="status">{label}</div>;
}

export function EmptyState({ title, detail, action }: { title: string; detail: string; action?: ReactNode }): React.JSX.Element {
  return <section className="state state-empty"><h2>{title}</h2><p>{detail}</p>{action}</section>;
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }): React.JSX.Element {
  const message = error instanceof ApiProblem ? formatProblem(error) : "The requested data could not be loaded.";
  const traceId = error instanceof ApiProblem ? error.traceId : undefined;
  return <section className="state state-error" role="alert"><h2>Something needs attention</h2><p>{message}</p>{traceId && <small>Trace: {traceId}</small>}{retry && <button type="button" onClick={retry}>Try again</button>}</section>;
}

export function ForbiddenState(): React.JSX.Element {
  return <section className="state state-error" role="alert"><h1>Access restricted</h1><p>Your current workspace role cannot open this area.</p></section>;
}

export function StaleState({ retry }: { retry: () => void }): React.JSX.Element {
  return <section className="state state-error" role="alert"><h2>This item changed elsewhere</h2><p>Refresh the current version before applying your edit again.</p><button type="button" onClick={retry}>Refresh current version</button></section>;
}
